export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives6.57eb78d5.jpg";